(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waylo-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init() {
    document.querySelectorAll('.wy-nav-v2').forEach(header => {
      if (header.dataset.searchReady) return;
      header.dataset.searchReady = 'true';
      const input = header.querySelector('.wy-nav-search input[type=search]');
      const panel = header.querySelector('.wy-predictive');
      if (!input || !panel) return;
      input.setAttribute('aria-controls', panel.id);
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-haspopup', 'dialog');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('autocomplete', 'off');
      const products = panel.querySelector('[data-search-products]');
      const links = panel.querySelector('[data-search-links]');
      const all = panel.querySelector('.wy-search-all');
      const status = panel.querySelector('[data-search-status]');
      const statusLabel = status.textContent;
      let timer, controller, suppressFocus = false;
      const close = () => { clearTimeout(timer); panel.hidden = true; input.setAttribute('aria-expanded', 'false'); controller?.abort(); };
      const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
      const format = value => new Intl.NumberFormat('sv-SE', {style:'currency',currency:panel.dataset.currency || 'SEK',maximumFractionDigits:0}).format(Number(value));
      const linkFor = item => { const a = document.createElement('a'); a.href = item.url; a.textContent = item.title || item.text; return a; };
      async function search() {
        const query = input.value.trim();
        controller?.abort();
        if (query.length < 2) { close(); return; }
        controller = new AbortController();
        all.href = panel.dataset.searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
        products.replaceChildren(); links.replaceChildren(); status.textContent = statusLabel; open();
        try {
          const url = new URL(panel.dataset.suggestUrl + '.json', window.location.origin);
          url.search = new URLSearchParams({q:query,'resources[type]':'product,collection,page','resources[limit]':'6','resources[limit_scope]':'each'});
          const response = await fetch(url,{signal:controller.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (input.value.trim() !== query) return;
          const result = data.resources.results;
          for (const product of result.products || []) {
            const a = document.createElement('a'); a.href = product.url; a.className = 'wy-search-product';
            const image = document.createElement('img'); image.src = product.featured_image?.url || product.image; image.alt = ''; image.width = 64; image.height = 64;
            const title = document.createElement('span'); title.textContent = product.title;
            const price = document.createElement('strong'); price.textContent = format(product.price);
            a.append(image,title,price); products.append(a);
          }
          for (const item of [...(result.collections || []), ...(result.pages || [])].slice(0,6)) links.append(linkFor(item));
          if (!(result.products || []).length) { const p = document.createElement('p'); p.textContent = document.documentElement.lang.startsWith('da') ? 'Ingen produkter fundet. Prøv et andet søgeord.' : 'Inga produkter hittades. Prova ett annat sökord.'; products.append(p); }
        } catch (error) { if (error.name !== 'AbortError') { const p = document.createElement('p'); p.textContent = document.documentElement.lang.startsWith('da') ? 'Åbn alle søgeresultater for at fortsætte.' : 'Öppna alla sökresultat för att fortsätta.'; products.replaceChildren(p); } }
      }
      input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(search,220);});
      input.addEventListener('focus',()=>{if(!suppressFocus && input.value.trim().length > 1) search();});
      panel.querySelector('.wy-search-close').addEventListener('click',()=>{close();suppressFocus=true;input.focus();suppressFocus=false;});
      header.addEventListener('keydown',event=>{if(event.key === 'Escape'){close();suppressFocus=true;input.focus();suppressFocus=false;} if(event.key === 'ArrowDown' && event.target === input && !panel.hidden){event.preventDefault();products.querySelector('a')?.focus();}});
      document.addEventListener('pointerdown',event=>{if(!header.contains(event.target))close();});
      header.addEventListener('focusout',event=>{if(!header.contains(event.relatedTarget))close();});
    });
  }
  init(); document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waylo-product"] && !Shopify.designMode) return;
  try {
    
function wireWayloConfig(root){
 if(root.dataset.configReady)return;root.dataset.configReady='true';
 root.querySelectorAll('.wy-gallery').forEach(gallery=>{
  const load=slide=>{const t=slide.querySelector('template[data-wy-slide-image]');if(t){t.replaceWith(t.content.cloneNode(true));}};
  if(!('IntersectionObserver' in window)){gallery.querySelectorAll('.wy-slide').forEach(load);return;}
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){load(entry.target);observer.unobserve(entry.target);}}),{root:gallery,rootMargin:'0px',threshold:.01});
  gallery.querySelectorAll('.wy-slide:has(template)').forEach(slide=>observer.observe(slide));
 });
 root.addEventListener('click',event=>{
 const button=event.target.closest('button');if(!button)return;
 if(button.hasAttribute('data-wy-open')){const dialog=root.querySelector('[data-wy-dialog="'+button.dataset.wyOpen+'"]');if(dialog){dialog.showModal();dialog._trigger=button;}}
 if(button.hasAttribute('data-wy-close'))button.closest('dialog').close();
 if(button.dataset.wyApply==='extras'){const items=[...root.querySelectorAll('[data-wy-addon]:checked')];root.querySelector('[data-wy-extras-label]').textContent=items.length?items.length+' TILLBEHÖR VALDA':'VÄLJ TILLBEHÖR';button.closest('dialog').close();}
 if(button.hasAttribute('data-wy-store')){root.querySelector('.wy-pickup-selected').textContent='Vald butik: '+button.dataset.wyStore;root.querySelectorAll('[data-wy-store]').forEach(b=>b.textContent=b===button?'Vald butik ✓':'Välj '+b.dataset.wyStore);}
 if(button.hasAttribute('data-wy-fulfillment')){const pickup=button.dataset.wyFulfillment==='pickup';root.querySelector('.wy-delivery-pane').hidden=pickup;root.querySelector('.wy-pickup-demo').hidden=!pickup;root.querySelectorAll('[data-wy-fulfillment]').forEach(tab=>tab.setAttribute('aria-selected',String(tab===button)));}
 });

 const variantData=root.querySelector('[data-wy-variants]');
 if(variantData){
  const variants=JSON.parse(variantData.textContent).variants;
  const input=root.querySelector('.wy-product-form [name=id]');
  const renderVariant=(variant,updateUrl=true)=>{
   if(!variant||!input)return;
   input.value=String(variant.id);
   const speed=root.querySelector('[data-wy-open="speed"] span'),tires=root.querySelector('[data-wy-open="tires"] span');
   if(speed)speed.textContent=variant.option1+' · '+variant.money;
   if(tires)tires.textContent=variant.option2;
   root.querySelectorAll('[data-wy-variant]').forEach(link=>{
    const option=variants.find(v=>String(v.id)===link.dataset.wyVariant);
    const speedDialog=link.closest('[data-wy-dialog]').dataset.wyDialog==='speed';
    link.hidden=speedDialog?option.option2!==variant.option2:option.option1!==variant.option1;
    link.classList.toggle('is-selected',option.id===variant.id);
    link.setAttribute('aria-current',option.id===variant.id?'true':'false');
   });
   const price=root.querySelector('.wy-buy .wy-price');
   if(price){price.replaceChildren();if(variant.compare>variant.price){const old=document.createElement('s');old.textContent=variant.compareMoney;price.append(old);}const strong=document.createElement('strong');strong.textContent=variant.money;price.append(strong);}
   const percent=variant.compare>variant.price?Math.round((variant.compare-variant.price)/variant.compare*100):0;
   let badge=root.querySelector('.wy-media-discount');
   if(!badge&&percent){badge=document.createElement('span');badge.className='wy-media-discount';root.querySelector('.wy-media').prepend(badge);}
   if(badge){badge.hidden=!percent;badge.textContent='SPARA '+percent+'%';}
   const sku=root.querySelector('.wy-sku');if(sku){sku.textContent='Artikelnummer: '+(variant.sku||'');sku.hidden=!variant.sku;}
   let stock=root.querySelector('.wy-stock');if(!stock){stock=document.createElement('p');stock.className='wy-stock';input.closest('form').after(stock);}stock.textContent=variant.stock;
   const qty=root.querySelector('.wy-product-form [name=quantity]');qty.min=variant.min;qty.step=variant.step;if(variant.max)qty.max=variant.max;else qty.removeAttribute('max');qty.value=Math.max(variant.min,Math.min(Number(qty.value)||variant.min,variant.max||Infinity));
   const submit=root.querySelector('.wy-product-form [name=add]');submit.disabled=!variant.available;submit.textContent=variant.available?'Lägg i varukorg':'Slut i lager';
   const sticky=root.querySelector('.wy-sticky-buy>span');if(sticky){const title=sticky.querySelector('strong').cloneNode(true);sticky.replaceChildren(title,document.createElement('br'),document.createTextNode(variant.money));}
   if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(history.state,'',url);}
  };
  renderVariant(variants.find(v=>String(v.id)===input.value),false);
  root.addEventListener('click',event=>{const link=event.target.closest('[data-wy-variant]');if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();renderVariant(variants.find(v=>String(v.id)===link.dataset.wyVariant));link.closest('dialog').close();});
  window.addEventListener('popstate',()=>renderVariant(variants.find(v=>String(v.id)===new URL(location.href).searchParams.get('variant'))||variants[0],false));
 }

 const form=root.querySelector('.wy-product-form');
 if(form)form.addEventListener('submit',async event=>{
  const addons=[...root.querySelectorAll('[data-wy-addon]:checked')];
  if(!addons.length)return;
  event.preventDefault();
  const submit=form.querySelector('[type=submit]');submit.disabled=true;
  const items=[{id:Number(form.querySelector('[name=id]').value),quantity:Number(form.querySelector('[name=quantity]').value)||1},...addons.map(input=>({id:Number(input.dataset.wyAddon),quantity:1}))];
  try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});if(!response.ok)throw new Error('Kunde inte lägga till tillbehören.');location.assign('/cart');}
  catch(error){submit.disabled=false;let message=form.querySelector('[data-wy-cart-error]');if(!message){message=document.createElement('p');message.dataset.wyCartError='';message.setAttribute('role','alert');form.append(message)}message.textContent=error.message;}
 });
 root.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>dialog._trigger?.focus()));
}
document.querySelectorAll('.wy-product').forEach(wireWayloConfig);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.wy-product').forEach(wireWayloConfig));

  } catch(e) { console.error(e); }
})();
})();
